<template>
  <div id="body-fat-index">
    <form @submit.prevent="calculate">
      <div>
        <select v-model="gender" id="gender">
          <option value>Gender</option>
          <option value="m">male</option>
          <option value="k">female</option>
        </select>
      </div>
      <div>
        <input
          type="number"
          min="0"
          v-model="waist"
          placeholder="Waist circumference (cm)"
          required="required"
        />
      </div>
      <div>
        <input
          type="number"
          min="0"
          v-model="hip"
          :disabled="gender == 'm'"
          placeholder="Hip circumference (cm)"
          required="required"
        />
      </div>
      <div>
        <input
          type="number"
          min="0"
          v-model="neck"
          placeholder="Neck circumference (cm)"
          required="required"
        />
      </div>
      <div>
        <input type="number" min="0" v-model="weight" placeholder="Weight (kg)" required="required" />
      </div>
      <div>
        <input type="number" min="0" v-model="height" placeholder="Height (cm)" required="required" />
      </div>
      <div>
        <input type="submit" value="Send" />
      </div>
    </form>
    <div class="result" v-if="showResult">
      Your body fat level:
      {{this.result}}
    </div>
  </div>
</template>

<script>
export default {
  name: "BodyFatIndexEn",
  methods: {
    calculate: function () {
      if (this.gender === "m") {
        this.result =
          495 /
            (1.0324 -
              0.19077 * Math.log10(Number(this.weight) - Number(this.neck)) +
              0.15456 * Math.log10(Number(this.height))) -
          450;
      } else if (this.gender === "k") {
        this.result =
          495 /
            (1.29579 -
              0.35004 *
                Math.log10(
                  Number(this.waist) + Number(this.hip) - Number(this.neck)
                ) +
              0.221 * Math.log10(Number(this.height))) -
          450;
      }

      this.result = this.result.toFixed(0) + "%";
      this.showResult = true;
    },
  },
  data() {
    return {
      gender: "",
      waist: null,
      hip: null,
      neck: null,
      weight: null,
      height: null,
      result: 0,
      showResult: false,
    };
  },
};
</script>

